import { checklistStatusTypes } from 'constants/checklist'
import { emitRedirectEvent } from 'helpers/events'
import { notify } from 'helpers/notification'
import { isRoomSetForRecording } from 'helpers/room'
import { getQueryParams } from 'helpers/urls'
import { userTypes } from 'helpers/user'
import * as apis from 'services/apis/room'
import {
    dispatchSetClassTitleAndRoomType,
    dispatchSetChecklistError,
    dispatchSetChecklistStatus,
} from 'store/dispatcher'
import { setTeacherGender } from 'utils/gender'
import { logger } from 'utils/logger'
import { sleep } from 'utils/utils'

import * as actions from '../actions/Room'
import { setUserInfo } from '../actions/User'

const { ERROR } = checklistStatusTypes

export const setRoomState = roomName => async dispatch => {
    try {
        const resp = await apis.getRoomState(roomName)
        if (resp.data.error) {
            return
        }

        dispatch(actions.setRoomState(resp.data))
    } catch (error) {
        logger.error(error)
    }
}

export const setRoomData = ({ roomName, userId }) => async dispatch => {
    try {
        /* check if user is allowed in the class and 
           room details */
        let resp = await apis.checkUserAndRoomStatus({
            roomName,
            userId,
        })
        const { success, result } = resp.data

        const handleChecklistError = reason => {
            dispatchSetChecklistError(reason)
            dispatchSetChecklistStatus(ERROR)
            dispatch(actions.setIsRoomLoading(false))
            return
        }

        if (!success)
            throw new Error(`api to check user permissions for room failed`)

        if (result.is_user_allowed) {
            // block the user if they are trying to join group study on a mobile device
            dispatchSetClassTitleAndRoomType({
                classTitle: result.class_title,
                roomType: result.room_type,
            })
        } else {
            const { skip } = getQueryParams()
            const skipLogin = skip?.includes('login')
            if (!skipLogin) {
                const reason = result.reason.toUpperCase()
                handleChecklistError(reason)
            }
        }

        /* .............................................. */

        /* fetch twilio token, some room & user data */
        resp = await apis.getTwilioToken({
            roomName,
        })

        if (resp.data.error) throw new Error(resp.data.message)

        const {
            token,
            room,
            state,
            gender,
            user_type,
            limnu_user_token,
        } = resp.data

        const isTeacher = user_type.toLowerCase() === userTypes.TEACHER

        if (isTeacher) {
            gender && setTeacherGender(gender)
        }

        dispatch(actions.setTwilioToken(token))
        dispatch(actions.setRoomName(room))
        dispatch(actions.setRoomState(state))
        dispatch(
            setUserInfo({
                gender,
            })
        )

        /* .............................................. */

        /* check if this classroom is being recorded */

        resp = await apis.getScheduledClassesForRecording()

        if (resp.data.error)
            throw new Error(
                `api to fetch details about classroom recording failed`
            )

        const scheduledClasses = resp.data.results
        const isRecording = isRoomSetForRecording(roomName, scheduledClasses)

        isRecording && dispatch(actions.setRecordingAlert(isRecording))

        /* .............................................. */

        dispatch(actions.setIsRoomLoading(false))
    } catch (error) {
        logger.error({
            msg: 'setRoomData failed',
            error,
        })
        const errMsg = error.message.toUpperCase()
        const path = errMsg === 'ROOM NOT FOUND' ? '/' : '/error'
        notify.error(`oh. something went wrong!`)
        await sleep(2000)
        emitRedirectEvent({ path, from: roomName })
    }
}
